export const SCREENER_TABS = [
  { id: "pullback", label: "Pullback", href: "/screener/pullback" },
  { id: "breakout", label: "Breakout", href: "/screener/breakout" },
  { id: "stage", label: "Stage Analysis", href: "/screener/stage" },
  { id: "rs_growth", label: "RS Growth", href: "/screener/rs-growth" },
] as const;
export type ScreenerTabId = (typeof SCREENER_TABS)[number]["id"];
export function parseTab(v: string | string[] | undefined): ScreenerTabId {
  return SCREENER_TABS.find((tab) => tab.id === v)?.id ?? "pullback";
}
